import { Eye, EyeOff } from "lucide-react";
import type { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface PasswordFieldProps {
  id: string;
  autoComplete: string;
  showPassword: boolean;
  onToggle: () => void;
  register: ReturnType<ReturnType<typeof useForm>["register"]>;
}

/**
 * Shared password input with show/hide toggle. Extracted from AuthForm
 * (SPEC-16) so ResetPasswordPage (SPEC-27) can reuse the same
 * affordance without duplicating the eye-toggle markup.
 */
export function PasswordField({
  id,
  autoComplete,
  showPassword,
  onToggle,
  register,
}: PasswordFieldProps) {
  return (
    <div className="relative">
      <Input
        id={id}
        type={showPassword ? "text" : "password"}
        autoComplete={autoComplete}
        className="pr-10"
        {...register}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute right-0 top-0 h-full px-3 text-muted-foreground hover:bg-transparent"
        onClick={onToggle}
        aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
      >
        {showPassword ? (
          <EyeOff className="h-4 w-4" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
